import React, { Fragment, useEffect, useState } from 'react'
import Sidebar from './Sidebar'
import { API } from "./constant"

import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

// images start 
import session from "../assets/masters/session.jpg"
import months from "../assets/masters/months.jpg"
import judge_criteria from "../assets/masters/judge_criteria.jpg"
import school_location from "../assets/masters/school_location.webp"
import students_data from "../assets/masters/students_data.avif"
import classes_img from "../assets/masters/classes.jpg"
import section_image from "../assets/masters/section_image.jpg"
// images end

// import sample excel file start 
import sample_excel from "../assets/sample/BrainBench_data_format.xlsx"
// import sample excel file end



// icons start 
import { MdClose } from "react-icons/md";
import { RiEditLine } from "react-icons/ri";
import { MdDeleteForever } from "react-icons/md";
import axios, { AxiosHeaders } from 'axios'
import { BiErrorCircle } from 'react-icons/bi';


//icons
import { IoMdClose, IoMdReturnRight } from "react-icons/io";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
// icons end


import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const names = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
];



const Masters = () => {

    const [updateTable, setupdateTable] = useState(false)


    // ================user data start ===================
    const [userData, setuserData] = useState([])
    // console.log(userData.role)
    useEffect(() => {
        axios.get(`${API}/login/logged-in-user`, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res.data)
                setuserData(res.data.data)
            })
            .catch((error) => {
                console.log(error)
            })
    }, [])
    // ================user data end ===================



    // -----------------operation on session  modal start ---------------------


    const [sessionModal, setsessionModal] = useState(false)


    const handleSessionModalOpen = () => {
        setsessionModal(true)
    }

    const handleSessionModalClose = () => {
        setsessionModal(false)
    }


    // creater session modal start 
    const [sessiondata, setsessiondata] = useState("")

    const submitSession = (e) => {
        e.preventDefault()
        const data = {
            name: sessiondata
        }
        axios.post(`${API}/session`, data, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res)
                toast.success(res.data.message)
                setupdateTable(!updateTable)
                clearFields()
            })
            .catch((error) => {
                console.log(error)
            })

    }
    // creater session modal end



    // fetch all session data start 
    const [allSessionData, setallSessionData] = useState([])
    useEffect(() => {
        axios.get(`${API}/session`, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res)
                setallSessionData(res.data.data)
            })
            .catch((error) => {
                console.log(error)
            })
    }, [updateTable])
    // fetch all session data end


    // edit session start 
    const [editSessionModal, seteditSessionModal] = useState(false)
    const [getParticularSession, setgetParticularSession] = useState("")
    const [editsessionName, seteditsessionName] = useState("")

    const handleEditSession = (item) => {
        seteditSessionModal(true)
        setgetParticularSession(item)
    }

    const editSession = async (id) => {
        const data = {
            name: editsessionName
        }
        await axios.put(`${API}/session/${id}`, data, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res.data.message)
                toast.success(res.data.message)
                seteditSessionModal(false)
                setupdateTable(!updateTable)
            })
            .catch((err) => {
                console.log(err)
            })
    }
    // edit session end



    // delete session start 
    const [deleteSessionModal, setdeleteSessionModal] = useState(false)
    const [delteSessionID, setdelteSessionID] = useState("")

    const handleDeleteSession = (id) => {
        setdeleteSessionModal(true)
        setdelteSessionID(id)
    }

    const deleteSession = async (id) => {
        await axios.delete(`${API}/session/${id}`, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                console.log(res)
                setdeleteSessionModal(false)
                toast.success(res.data.message)
                setdelteSessionID("")
                setupdateTable(!updateTable)
            })
            .catch((err) => {
                console.log(err)
            })

    }
    // delete session end
    // ---------------operation on session  modal end--------------------





    //-------------------- operation on months modal start -------------
    const [monthsModal, setmonthsModal] = useState(false)

    const handleMonthModalOpen = () => {
        setmonthsModal(true)
    }

    const handleMonthCloseModal = () => {
        setmonthsModal(false)
    }
    const [monthsName, setmonthsName] = useState("")


    // create months start
    const submitMonths = (e) => {
        e.preventDefault()
        const data = {
            name: monthsName
        }
        axios.post(`${API}/months`, data, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res)
                setupdateTable(!updateTable)
                toast.success(res.data.message)
                clearFields()
            })
            .catch((error) => {
                console.log(error)
            })
    }
    // create months end

    // get all months data start
    const [allMonthsData, setallMonthsData] = useState([])
    useEffect(() => {
        axios.get(`${API}/months`, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res)
                setallMonthsData(res.data.data)
            })
            .catch((error) => {
                console.log(error)
            })
    }, [updateTable])
    // get all months data end


    // edit months start 
    const [editMonthsModal, seteditMonthsModal] = useState(false)
    const [getParticularMonths, setgetParticularMonths] = useState("")
    const [editMonthName, seteditMonthName] = useState("")

    const handleEditMonths = (item) => {
        seteditMonthsModal(true)
        setgetParticularMonths(item)
    }


    const editMonthsName = async (id) => {
        const data = {
            name: editMonthName
        }
        await axios.put(`${API}/months/${id}`, data, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res)
                setupdateTable(!updateTable)
                seteditMonthsModal(false)
                toast.success(res.data.message)
            })
            .catch((err) => {
                console.log(err)
            })
    }

    // edit months end



    // delete months start 
    const [deleteMonthsModal, setdeleteMonthsModal] = useState(false)
    const [deleteMonthsId, setdeleteMonthsId] = useState("")

    const handleDeleteMonthModal = (id) => {
        setdeleteMonthsModal(true)
        setdeleteMonthsId(id)
    }


    const deleteMonths = async (id) => {
        await axios.delete(`${API}/months/${id}`, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                setupdateTable(!updateTable)
                setdeleteMonthsModal(false)
                toast.success(res.data.message)
            })
            .catch((err) => {
                toast.error(err.response.data.message)
            })
    }
    // delete months end


    // ------------------operation on months modal emd----------------



    // ---------------------operation on judge criteria start--------------------- 

    const [judgeCriteriaModal, setjudgeCriteriaModal] = useState(false)

    const handlejudgeCriteriaModalOpen = () => {
        setjudgeCriteriaModal(true)
    }


    const handlejudgeCriteriaModalClose = () => {
        setjudgeCriteriaModal(false)
    }

    // create judge criteria start
    const [judgecriteria, setjudgecriteria] = useState("")

    const submitJudgeCriteria = (e) => {
        e.preventDefault()
        const data = {
            name: judgecriteria
        }
        axios.post(`${API}/judge-criteria`, data)
            .then((res) => {
                // console.log(res)
                setupdateJudgeTable(!updateJudgeTable)
                toast.success(res.data.message)
                clearFields()
            })
            .catch((error) => {
                console.log(error)
            })
    }
    // create judge criteria end

    // get all judge criteria start 
    const [getAllJudgeCriteria, setgetAllJudgeCriteria] = useState([])
    const [updateJudgeTable, setupdateJudgeTable] = useState(false)
    useEffect(() => {
        axios.get(`${API}/judge-criteria`)
            .then((res) => {
                // console.log(res)
                setgetAllJudgeCriteria(res.data.data)
            })
            .catch((error) => {
                console.log(error)
            })
    }, [updateJudgeTable])
    // get all judge criteria end


    // edit judge criteria start 
    const [editJudgeCriteriaModal, seteditJudgeCriteriaModal] = useState(false)
    const [getParticularJudgeCriteria, setgetParticularJudgeCriteria] = useState("")
    const [editJudgeCriteria, seteditJudgeCriteria] = useState("")


    const handleEditJudgeCriteriaModal = (item) => {
        seteditJudgeCriteriaModal(true)
        setgetParticularJudgeCriteria(item)
    }

    const handleEditJudgeCriteria = async (id) => {
        const data = {
            name: editJudgeCriteria
        }
        await axios.put(`${API}/judge-criteria/${id}`, data, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                toast.success(res.data.message)
                seteditJudgeCriteriaModal(false)
                setupdateJudgeTable(!updateJudgeTable)
            })
            .catch((error) => {
                toast.error(error.reponse.data.message)
            })
    }
    // edit judge criteria end



    // delete judge criteria modal start 
    const [deleteJudgeCriteriaModal, setdeleteJudgeCriteriaModal] = useState(false)
    const [deleteJudgeCriteriaId, setdeleteJudgeCriteriaId] = useState("")

    const handleDeleteJudgeCriteria = (id) => {
        setdeleteJudgeCriteriaId(id)
        setdeleteJudgeCriteriaModal(true)
    }


    const deleteJudgeCriteria = async (id) => {
        await axios.delete(`${API}/judge-criteria/${id}`, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res)
                setdeleteJudgeCriteriaModal(false)
                setdeleteJudgeCriteriaId("")
                setupdateJudgeTable(!updateJudgeTable)
                toast.success(res.data.message)
            })
            .catch((err) => {
                toast.error(err.response.data.message)
            })
    }
    // delete judge criteria modal end


    // ---------------------operation on judge criteria end--------------------- 



    //---------------- operation school location start -----------------------
    const [schoolLocationModal, setschoolLocationModal] = useState(false)

    const handleSchoolLocationOpen = () => {
        setschoolLocationModal(true)
    }

    const handleSchoolLocationClose = () => {
        setschoolLocationModal(false)
    }


    // create start 
    const [schoolLocation, setschoolLocation] = useState("")
    const submitSchoolLocation = (e) => {
        e.preventDefault()
        const data = {
            name: schoolLocation
        }

        axios.post(`${API}/school-location`, data)
            .then((res) => {
                // console.log(res)
                setupdateSchoolLocationTable(!updateJudgeTable)
                toast.success(res.data.message)
                clearFields()
            })
            .catch((error) => {
                console.log(error)
            })
    }

    // create end

    // get all school location start 
    const [getAllSchoolLocation, setgetAllSchoolLocation] = useState([])
    const [updateSchoolLocationTable, setupdateSchoolLocationTable] = useState(false)
    useEffect(() => {
        axios.get(`${API}/school-location`)
            .then((res) => {
                console.log(res)
                setgetAllSchoolLocation(res.data.data)
            })
            .catch((error) => {
                console.log(error)
            })
    }, [updateSchoolLocationTable])
    // get all school location end



    // edit school location start 
    const [editSchoolLocationModal, seteditSchoolLocationModal] = useState(false)
    const [getParticularSchoolLocation, setgetParticularSchoolLocation] = useState("")
    const [editParticularSchoolLocation, seteditParticularSchoolLocation] = useState("")

    const handleEditSchoolLocationModal = (item) => {
        seteditSchoolLocationModal(true)
        setgetParticularSchoolLocation(item)
    }


    const editSchoolLocation = async (id) => {
        const data = {
            name: editParticularSchoolLocation
        }
        await axios.put(`${API}/school-location/${id}`, data, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                seteditSchoolLocationModal(false)
                setupdateSchoolLocationTable(!updateSchoolLocationTable)
                toast.success(res.data.message)
            })
            .catch((error) => {
                toast.error(error.response.data.message)
            })
    }
    // edit school location end


    // delete school location start 
    const [deleteSchoolLocationModal, setdeleteSchoolLocationModal] = useState(false)
    const [deleteSchoolLocationID, setdeleteSchoolLocationID] = useState("")

    const handleDeleteSchoolLocationModal = (id) => {
        setdeleteSchoolLocationModal(true)
        setdeleteSchoolLocationID(id)
    }

    const deleteSchoolLocation = async (id) => {
        await axios.delete(`${API}/school-location/${id}`, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                setdeleteSchoolLocationModal(false)
                setdeleteSchoolLocationID("")
                toast.success(res.data.message)
                setupdateSchoolLocationTable(!updateJudgeTable)
            })
            .catch((error) => {
                toast.error(error.response.data.message)
            })
    }
    // delete school location end


    //---------------- operation school location end -----------------------



    //---------------- opetaion on upload students data start -------------

    const [uploadStudentsModal, setuploadStudentsModal] = useState(false)

    const handleUploadStudentsOpen = () => {
        setuploadStudentsModal(true)
    }

    const handleUploadStudentsClose = () => {
        setuploadStudentsModal(false)
    }

    // Function to handle file upload with headers


    const [uploadError, setUploadError] = useState(null);
    const [uploadSuccess, setUploadSuccess] = useState(null);


    const handleFileUpload = async (event) => {
        event.preventDefault(); // Prevent default form submission

        const fileInput = event.target.querySelector('input[type="file"]');
        const file = fileInput.files[0];

        if (!file) {
            setUploadError('Please select a file to upload.');
            return;
        }

        // Create FormData object to send the file
        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await axios.post(`${API}/students-upload`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data', // Required for file uploads
                    token: localStorage.getItem('token'), // Same header as in handleReportCard
                },
            });

            // Handle successful upload
            setUploadSuccess('File uploaded successfully!');
            setUploadError(null);
            console.log('Upload response:', response.data);

            // Optionally reset the form
            event.target.reset();
        } catch (error) {
            console.error('Upload error:', error);
            setUploadError('Failed to upload file. Please try again.');
            setUploadSuccess(null);
        }
    };

    //---------------- opetaion on upload students data end ---------------






    // ======================= class operation start ==============================

    const [showModalClass, setshowModalClass] = useState(false)


    // -----------create class start ----------------
    const [class_name, setclass_name] = useState("")

    const handleCreateClass = async (e) => {
        e.preventDefault()
        const data = {
            name: class_name
        }
        await axios.post(`${API}/create-class`, data, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res)
                alert(res.data.message)
                clearFields()
                setupdateTable(!updateTable)
            })
            .catch((err) => {
                console.log(err)
            })
    }
    //----------- create class end------------------

    // --------------get all class data start ----------
    const [allClassDATA, setallClassDATA] = useState([])
    useEffect(() => {
        axios.get(`${API}/create-class`)
            .then((res) => {
                // console.log(res)
                setallClassDATA(res.data.data)
            })
            .catch((err) => {
                console.log(err)
            })
    }, [updateTable])
    // ------------get all class data end------------

    // ------------edit class data start -----------
    const [EditClassModal, setEditClassModal] = useState("")
    const [selectedRowData, setselectedRowData] = useState("")
    const [editClassName, seteditClassName] = useState("")

    const handleEditClass = (item) => {
        setEditClassModal(true)
        setselectedRowData(item)
    }
    const editClass = (id) => {
        const data = {
            name: editClassName
        }
        axios.put(`${API}/create-class/${id}`, data, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res)
                alert(res.data.message)
                setupdateTable(!updateTable)
                setEditClassModal(false)


            })
            .catch((err) => {
                console.log(err)
            })
    }
    // ------------edit class data end--------------

    // -----------delete class start ----------------
    const [deletePopUp, setdeletePopUp] = useState(false)
    const [DeleteId, setDeleteId] = useState(false)

    const handledeletePopUp = (id) => {
        setdeletePopUp(true)
        setDeleteId(id)
    }

    const handleDelete = (id) => {
        axios.delete(`${API}/create-class/${id}`)
            .then((res) => {
                console.log(res)
                // alert(res.data.message)
                setdeletePopUp(false)
                setupdateTable(!updateTable)

            })
            .catch((err) => {
                console.log(err)
            })

    }
    // -----------delete class end-----------------
    // ======================= class operation end=================================





    // ======================= SECTION operation START =================================
    const [showModalSection, setshowModalSection] = useState(false)
    //------------ submit section start ----------------
    const [classNameforSection, setClassNameforSection] = React.useState("");
    const [sectionName, setSectionName] = React.useState([]);

    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        setSectionName(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };


    const handleSubmitSection = async (e) => {
        e.preventDefault()
        const data = {
            class_name: classNameforSection,
            sections: sectionName
        }
        await axios.post(`${API}/create-section`, data, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                console.log(res)
                alert(res.data.message)
                clearFields()
                setupdateTable(!updateTable)
                setshowModalSection(false)
            })
            .catch((err) => {
                console.log(err)
                alert(err.response.data.message)

            })
    }
    //------------ submit section start ----------------



    //------------ get section start ----------------
    const [get_section, setget_section] = useState([])
    // console.log(get_section)
    useEffect(() => {
        axios.get(`${API}/create-section`, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res.data.data)
                setget_section(res.data.data)
            })
            .catch((err) => {
                console.log(err)
            })
    }, [updateTable])
    //------------ get section end ----------------


    // ----------edit section start ---------------
    const [editshowModalSection, seteditshowModalSection] = useState(false)
    const [editclassNameforSection, seteditClassNameforSection] = React.useState("");
    const [editsectionName, seteditSectionName] = React.useState([]);
    const [editsectionID, seteditsectionID] = useState("")

    const handleEditSection = async (id) => {
        seteditshowModalSection(true)
        seteditsectionID(id)

        await axios.get(`${API}/create-section/${id}`, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                console.log(res.data.data)
                seteditClassNameforSection(res.data.data.class_name)
                seteditSectionName(res.data.data.sections)
            })
            .catch((err) => {
                console.log(err)
            })
    }

    const handleEditSubmitSection = async (id) => {

        const data = {
            class_name: editclassNameforSection,
            sections: editsectionName
        }

        await axios.put(`${API}/create-section/${id}`, data, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res.data.data.message)
                seteditshowModalSection(false)
                setupdateTable(!updateTable)
            })
            .catch((err) => {
                console.log(err)
            })

    }


    const handleEditChange = (event) => {
        const {
            target: { value },
        } = event;
        seteditSectionName(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };
    // ----------edit section end ---------------



    // -----------delete section start ------------------
    const [deleteSectionPopUp, setdeleteSectionPopUp] = useState(false)
    const [DeleteSectionId, setDeleteSectionId] = useState("")


    const handledeleteSectionPopUp = (id) => {
        setdeleteSectionPopUp(true)
        setDeleteSectionId(id)
    }

    const handleDeleteSection = (id) => {
        axios.delete(`${API}/create-section/${id}`, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                console.log(res)
                // alert(res.data.message)
                setdeleteSectionPopUp(false)
                setupdateTable(!updateTable)

            })
            .catch((err) => {
                console.log(err)
            })

    }

    // -----------delete section end ------------------




    // ======================= section operation end=================================



    // ==================operation on default update start ====================


    const [defaultModal, setdefaultModal] = useState(false)
    const [fetchedSession, setfetchedSession] = useState("")
    const [fetchedAssessmentPeriod, setfetchedAssessmentPeriod] = useState("")
    // console.log("session:", fetchedSession, "month:", fetchedAssessmentPeriod)

    const handleDefaultModalOpen = () => {
        setdefaultModal(true)
    }

    useEffect(() => {
        axios.get((`${API}/default-session/689ada445027a6bbae0adf3a`))
            .then((res) => {
                // console.log(res.data.data.default_session)
                setfetchedSession(res.data.data.default_session)
            })
            .catch((error) => {
                console.log(error)
            })
    }, [])

    useEffect(() => {
        axios.get((`${API}/default-assessment-period/689ad9de5027a6bbae0adf38`))
            .then((res) => {
                // console.log(res.data.data.default_month)
                setfetchedAssessmentPeriod(res.data.data.default_month)
            })
            .catch((error) => {
                console.log(error)
            })
    }, [])

    const handleUpdateDefaultSession = async () => {
        const data = {
            default_session: fetchedSession
        }
        await axios.put(`${API}/default-session/689ada445027a6bbae0adf3a`, data, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res)
                toast.success(res.data.message)
            })
            .catch((error) => {
                console.log(error)
            })
    }

    const handleUpdateDefaultAssessmentPeriod = async () => {
        const data = {
            default_month: fetchedAssessmentPeriod
        }
        await axios.put(`${API}/default-assessment-period/689ad9de5027a6bbae0adf38`, data, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res)
                toast.success(res.data.message)
            })
            .catch((error) => {
                console.log(error)
            })
    }
    // ==================operation on default update end ====================




    // clear fields start 
    const clearFields = () => {
        setsessiondata("")
        setmonthsName("")
        setjudgecriteria("")
        setschoolLocation("")
        setclass_name("")
        setClassNameforSection("")
        setSectionName([])


    }
    // clear fields end

    return (
        <div>
            <div>
                <Sidebar>
                    <ToastContainer position="top-right" autoClose={3000} />
                    {userData.role === 'Super Admin' ? (
                        <div>
                            <div className='bg-theme_sky_blue h-[10vh] w-full flex items-center px-[20px] text-theme_white'>
                                <div>
                                    <p>Masters</p>
                                </div>
                            </div>


                            {/* page content start  */}

                            {/* <div className='m-[15px] flex gap-3'>
                        <div className='w-[20%]'>
                            <label >Search Name:</label>
                            <input type="search" className='bg-theme_white px-[10px] py-[5px] w-full rounded-3xl outline-theme_yellow_dark border-theme_sky_blue border-[1px]' />
                        </div>

                        <div className='w-[20%]'>
                            <label >Search Class:</label>
                          
                            <select className=' w-full ' >
                                <option value="">Select Class</option>
                                <option value="">I</option>
                                <option value="">II</option>
                                <option value="">III</option>
                                <option value="">IV</option>
                                <option value="">V</option>
                                <option value="">VI</option>
                            </select>
                        </div>

                        <div className='w-[20%]'>
                            <label >Search Section:</label>
                          
                            <select className='w-full' >
                                <option value="">Select Section</option>
                                <option value="">A</option>
                                <option value="">B</option>
                                <option value="">C</option>
                                <option value="">D</option>
                                <option value="">E</option>
                                <option value="">F</option>
                            </select>
                        </div>

                        <div className='w-[20%]'>
                            <label >Search Assessment Period:</label>
                           
                            <select className=' w-full' >
                                <option value="">Select Month</option>
                                <option value="">January</option>
                                <option value="">February</option>
                                <option value="">March</option>
                                <option value="">April</option>
                                <option value="">May</option>
                                <option value="">June</option>
                            </select>
                        </div>

                    </div> */}



                            {/* cards container start  */}
                            <div className='card_container'>

                                <div onClick={() => setshowModalClass(true)} className='card w-[350px] bg-theme_red text-theme_white  pb-[30px] rounded-lg shadow-md shadow-theme_border cursor-pointer' >
                                    <div className='rounded-lg h-[150px]'>
                                        <img src={classes_img} className='rounded-tl-lg rounded-tr-lg h-full w-full object-cover' alt="sesion image" />
                                    </div>

                                    <hr className='h-[2px] mb-[10px]'>
                                    </hr>

                                    <h3 className='px-[20px] '>
                                        Class
                                    </h3>

                                    <p className='px-[20px] text-[13px]'>I,II,III,IV</p>

                                </div>




                                <div onClick={() => setshowModalSection(true)} className='card w-[350px] bg-theme_sky_blue text-theme_white  pb-[30px] rounded-lg shadow-md shadow-theme_border cursor-pointer' >
                                    <div className='rounded-lg h-[150px]'>
                                        <img src={section_image} className='rounded-tl-lg rounded-tr-lg h-full w-full object-cover' alt="sesion image" />
                                    </div>

                                    <hr className='h-[2px] mb-[10px]'>
                                    </hr>

                                    <h3 className='px-[20px] '>
                                        Sections
                                    </h3>

                                    <p className='px-[20px] text-[13px]'>A,B.C</p>

                                </div>


                                <div onClick={handleSessionModalOpen} className='card w-[350px] bg-theme_green text-theme_white  pb-[30px] rounded-lg shadow-md shadow-theme_border cursor-pointer' >
                                    <div className='rounded-lg h-[150px]'>
                                        <img src={session} className='rounded-tl-lg rounded-tr-lg h-full w-full object-cover' alt="sesion image" />
                                    </div>

                                    <hr className='h-[2px] mb-[10px]'>
                                    </hr>

                                    <h3 className='px-[20px] '>
                                        Session
                                    </h3>

                                    <p className='px-[20px] text-[13px]'>2024-2025-,2025-2026</p>

                                </div>



                                <div onClick={handleMonthModalOpen} className='card w-[350px] bg-theme_blue text-theme_white  pb-[30px] rounded-lg shadow-md shadow-theme_border cursor-pointer' >
                                    <div className='rounded-lg h-[150px]'>
                                        <img src={months} className='rounded-tl-lg rounded-tr-lg h-full w-full object-cover' alt="sesion image" />
                                    </div>

                                    <hr className='h-[2px] mb-[10px]'>
                                    </hr>

                                    <h3 className='px-[20px] '>
                                        Months
                                    </h3>

                                    <p className='px-[20px] text-[13px]'>January, February, March, April, May</p>

                                </div>



                                <div onClick={handleDefaultModalOpen} className='card w-[350px] bg-theme_black text-theme_white  pb-[30px] rounded-lg shadow-md shadow-theme_border cursor-pointer' >
                                    <div className='rounded-lg h-[150px]'>
                                        <img src={months} className='rounded-tl-lg rounded-tr-lg h-full w-full object-cover' alt="sesion image" />
                                    </div>

                                    <hr className='h-[2px] mb-[10px]'>
                                    </hr>

                                    <h3 className='px-[20px] '>
                                        Default Months and session
                                    </h3>

                                    <p className='px-[20px] text-[13px]'>January, February, March, April, May</p>

                                </div>



                                <div onClick={handlejudgeCriteriaModalOpen} className='card w-[350px] bg-theme_yellow_dark text-theme_white  pb-[30px] rounded-lg shadow-md shadow-theme_border cursor-pointer' >
                                    <div className='rounded-lg h-[150px]'>
                                        <img src={judge_criteria} className='rounded-tl-lg rounded-tr-lg h-full w-full object-cover' alt="sesion image" />
                                    </div>

                                    <hr className='h-[2px] mb-[10px]'>
                                    </hr>

                                    <h3 className='px-[20px] '>
                                        Judge Criteria
                                    </h3>

                                    <p className='px-[20px] text-[13px]'>Emerging,Developing,Achieved</p>

                                </div>



                                <div onClick={handleSchoolLocationOpen} className='card w-[350px] bg-theme_pink text-theme_white  pb-[30px] rounded-lg shadow-md shadow-theme_border cursor-pointer' >
                                    <div className='rounded-lg h-[150px] '>
                                        <img src={school_location} className='rounded-tl-lg rounded-tr-lg h-full w-full object-cover bg-white' alt="sesion image" />
                                    </div>

                                    <hr className='h-[2px] mb-[10px]'>
                                    </hr>

                                    <h3 className='px-[20px] '>
                                        School Location
                                    </h3>

                                    <p className='px-[20px] text-[13px]'>GHAZIABAD, KANPUR, LUCKNOW</p>

                                </div>



                                <div onClick={handleUploadStudentsOpen} className='card w-[350px] bg-theme_yellow_light text-theme_white  pb-[30px] rounded-lg shadow-md shadow-theme_border cursor-pointer' >
                                    <div className='rounded-lg h-[150px]'>
                                        <img src={students_data} className='rounded-tl-lg rounded-tr-lg h-full w-full object-cover' alt="sesion image" />
                                    </div>

                                    <hr className='h-[2px] mb-[10px]'>
                                    </hr>

                                    <h3 className='px-[20px] '>
                                        Upload Students
                                    </h3>

                                    <p className='px-[20px] text-[13px]'>Upload student data</p>

                                </div>





                            </div>
                            {/* cards container end */}
                            {/* page content end */}



                            {/* ====================modals start=======================================  */}
                            {/* ---------session modal start-------------  */}
                            {
                                sessionModal && (
                                    <div className='inset-0  fixed  flex'>
                                        {/* backdrop start */}
                                        <div className='absolute inset-0 bg-black bg-opacity-50' onClick={handleSessionModalClose}>
                                        </div>
                                        {/* backdrop end */}


                                        {/* modal panel start  */}
                                        <div className={`absolute top-[15vh] right-0 w-[40%] bg-theme_yellow_light overflow-auto transition-transform duration-300 ease-out `}
                                            style={{ height: 'calc(100% - 10vh)' }}
                                        >

                                            <div className='p-6'>
                                                <div className='flex justify-between items-center mb-4'>
                                                    <h2>
                                                        Add session
                                                    </h2>

                                                    <button
                                                        className='text-gray-600 hover:text-gray-800' onClick={handleSessionModalClose}>
                                                        ✕
                                                    </button>
                                                </div>
                                                <p>Create your session-</p>

                                                <div>
                                                    <div>
                                                        <form >
                                                            <div className='w-full my-[10px]'>
                                                                <div>
                                                                    <label >Session:</label>
                                                                </div>
                                                                <input value={sessiondata} onChange={(e) => setsessiondata(e.target.value)} type="text" className='w-[70%]' />
                                                            </div>


                                                            <div className='my-[20px] flex gap-4'>
                                                                <button onClick={submitSession} className='bg-theme_yellow_dark_transparent text-white px-[20px] py-[10px] rounded-lg'>Submit</button>
                                                                <button className='bg-theme_border text-theme_black px-[20px] py-[10px] rounded-lg'>Clear</button>
                                                            </div>
                                                        </form>
                                                    </div>

                                                    <div className='my-[10px]'>
                                                        <table className='border border-separate'>
                                                            <thead className=''>
                                                                <th>Sno.</th>
                                                                <th>Session</th>
                                                                <th>Edit</th>
                                                                <th>Delete</th>
                                                            </thead>
                                                            <tbody>
                                                                {/* <tr className='text-center '>
                                                            <td>1</td>
                                                            <td>2024-2025</td>
                                                            <td><RiEditLine size={20} /></td>
                                                            <td><MdDeleteForever size={20} /></td>
                                                        </tr> */}
                                                                {
                                                                    allSessionData && allSessionData.map((item, index) => {
                                                                        return (

                                                                            <tr key={index} className='text-center '>
                                                                                <td>{index + 1}</td>
                                                                                <td>{item.name}</td>
                                                                                <td><RiEditLine size={20} onClick={() => handleEditSession(item)} /></td>
                                                                                <td><MdDeleteForever size={20} onClick={() => handleDeleteSession(item._id)} /></td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                }
                                                            </tbody>
                                                        </table>

                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                        {/* modal panel end */}

                                    </div>
                                )
                            }


                            {
                                editSessionModal && (
                                    <div className='inset-0 flex justify-center items-center fixed z-[50] bg-[#1c1d1f]/30' >
                                        <div className='w-[350px]'>
                                            <div className='bg-theme_blue py-[10px] px-[10px] flex justify-between'><h5 className='text-white text-[25px]'>Edit Session</h5> <button onClick={() => seteditSessionModal(false)}><IoMdClose size={30} color='white' /></button></div>
                                            {/* input field block start */}
                                            <div className='p-[10px] bg-white'>

                                                <div className='p-[5px] flex justify-between'>
                                                    <div className='w-full'>
                                                        <label htmlFor="edit_school_location">session:</label>
                                                        <input id='edit_school_location' value={getParticularSession?.name}
                                                            onChange={(e) => {
                                                                const newClassname = e.target.value
                                                                setgetParticularSession((prev) => ({ ...prev, name: newClassname }))
                                                                seteditsessionName(newClassname)
                                                            }
                                                            }
                                                            className='w-full p-[8px] rounded-md outline-none bg-[#121212] text-white' type="text" placeholder='2025-2026' />
                                                    </div>

                                                </div>
                                                <div className=' p-[5px] flex justify-start my-[10px]'>
                                                    <button onClick={() => editSession(getParticularSession._id)} className='hover:bg-[#6C7AE0] bg-[#121212] px-[15px] py-[5px] text-white rounded-md' >Update</button>
                                                </div>

                                            </div>
                                            {/* input field block end */}
                                        </div>
                                    </div>
                                )
                            }




                            {
                                deleteSessionModal && (
                                    <div className='inset-0 fixed flex justify-center items-center bg-black/70'>
                                        <div className='bg-theme_sky_blue text-white w-[30%] px-[10px] py-[20px] '>
                                            <div className='flex justify-between items-center pb-[20px]'>
                                                <div>
                                                    <h1 className='text-[20px]'>Delete Session</h1>
                                                </div>
                                                <div>
                                                    <MdClose onClick={() => setdeleteSessionModal(false)} size={30} />
                                                </div>
                                            </div>
                                            <hr />
                                            <div className='mt-[20px] '>
                                                <p className='w-[95%] text-center'>
                                                    Deleting Session might affect your records. Do you still want to delete?
                                                </p>
                                                <div className='flex justify-around mt-[30px]'>
                                                    <button onClick={() => deleteSession(delteSessionID)} className='px-[10px] py-[5px] bg-theme_white text-black hover:bg-theme_red hover:text-white'>Delete</button>
                                                    <button onClick={() => setdeleteSessionModal(false)} className='px-[10px] py-[5px] bg-theme_white text-black hover:bg-theme_green hover:text-white'>Cancel</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )

                            }



                            {/* ---------session modal end----------------- */}


                            {/* -------------masters modals start---------------  */}
                            {
                                monthsModal && (
                                    <div className='inset-0  fixed  flex'>
                                        {/* backdrop start */}
                                        <div className='absolute inset-0 bg-black bg-opacity-50' onClick={handleMonthCloseModal}>
                                        </div>
                                        {/* backdrop end */}


                                        {/* modal panel start  */}
                                        <div className={`absolute top-[15vh] right-0 w-[40%] bg-theme_yellow_light overflow-auto transition-transform duration-300 ease-out `}
                                            style={{ height: 'calc(100% - 10vh)' }}
                                        >

                                            <div className='p-6'>
                                                <div className='flex justify-between items-center mb-4'>
                                                    <h2>
                                                        Add Months
                                                    </h2>

                                                    <button
                                                        className='text-gray-600 hover:text-gray-800' onClick={handleMonthCloseModal}>
                                                        ✕
                                                    </button>
                                                </div>
                                                <p>Create your months-</p>

                                                <div>
                                                    <div>
                                                        <form >
                                                            <div className='w-full my-[10px]'>
                                                                <div>
                                                                    <label >Months:</label>
                                                                </div>
                                                                <input value={monthsName} onChange={(e) => setmonthsName(e.target.value)} type="text" className='w-[70%]' />
                                                            </div>


                                                            <div className='my-[20px] flex gap-4'>
                                                                <button onClick={submitMonths} className='bg-theme_yellow_dark_transparent text-white px-[20px] py-[10px] rounded-lg'>Submit</button>
                                                                <button onClick={clearFields} className='bg-theme_border text-theme_black px-[20px] py-[10px] rounded-lg'>Clear</button>
                                                            </div>
                                                        </form>
                                                    </div>

                                                    <div className='my-[10px]'>
                                                        <table className='border border-separate'>
                                                            <thead className=''>
                                                                <th>Sno.</th>
                                                                <th>Months</th>
                                                                <th>Edit</th>
                                                                <th>Delete</th>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    allMonthsData && allMonthsData.map((item, index) => {
                                                                        return (

                                                                            <tr key={index} className='text-center '>
                                                                                <td>{index + 1}</td>
                                                                                <td>{item.name}</td>
                                                                                <td><RiEditLine size={20} onClick={() => handleEditMonths(item)} /></td>
                                                                                <td><MdDeleteForever size={20} onClick={() => handleDeleteMonthModal(item._id)} /></td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                }
                                                            </tbody>
                                                        </table>

                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                        {/* modal panel end */}

                                    </div>
                                )
                            }


                            {
                                editMonthsModal && (
                                    <div className='inset-0 flex justify-center items-center fixed z-[50] bg-[#1c1d1f]/30' >
                                        <div className='w-[350px]'>
                                            <div className='bg-theme_blue py-[10px] px-[10px] flex justify-between'>
                                                <h5 className='text-white text-[25px]'>Edit Months</h5>
                                                <button onClick={() => seteditMonthsModal(false)}><IoMdClose size={30} color='white' /></button></div>
                                            {/* input field block start */}
                                            <div className='p-[10px] bg-white'>

                                                <div className='p-[5px] flex justify-between'>
                                                    <div className='w-full'>
                                                        <label htmlFor="edit_school_location">Month:</label>
                                                        <input id='edit_school_location' value={getParticularMonths?.name}
                                                            onChange={(e) => {
                                                                const newClassname = e.target.value
                                                                setgetParticularMonths((prev) => ({ ...prev, name: newClassname }))
                                                                seteditMonthName(newClassname)
                                                            }
                                                            }
                                                            className='w-full p-[8px] rounded-md outline-none bg-[#121212] text-white' type="text" placeholder='January' />
                                                    </div>

                                                </div>
                                                <div className=' p-[5px] flex justify-start my-[10px]'>
                                                    <button onClick={() => editMonthsName(getParticularMonths._id)} className='hover:bg-[#6C7AE0] bg-[#121212] px-[15px] py-[5px] text-white rounded-md' >Update</button>
                                                </div>

                                            </div>
                                            {/* input field block end */}
                                        </div>
                                    </div>
                                )
                            }


                            {
                                deleteMonthsModal && (
                                    <div className='inset-0 fixed flex justify-center items-center bg-black/70'>
                                        <div className='bg-theme_sky_blue text-white w-[30%] px-[10px] py-[20px] '>
                                            <div className='flex justify-between items-center pb-[20px]'>
                                                <div>
                                                    <h1 className='text-[20px]'>Delete Month</h1>
                                                </div>
                                                <div>
                                                    <MdClose onClick={() => setdeleteMonthsModal(false)} size={30} />
                                                </div>
                                            </div>
                                            <hr />
                                            <div className='mt-[20px] '>
                                                <p className='w-[95%] text-center'>
                                                    Deleting Month might affect your records. Do you still want to delete?
                                                </p>
                                                <div className='flex justify-around mt-[30px]'>
                                                    <button onClick={() => deleteMonths(deleteMonthsId)} className='px-[10px] py-[5px] bg-theme_white text-black hover:bg-theme_red hover:text-white'>Delete</button>
                                                    <button onClick={() => setdeleteMonthsModal(false)} className='px-[10px] py-[5px] bg-theme_white text-black hover:bg-theme_green hover:text-white'>Cancel</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }

                            {/*------------ masters modals end------------------ */}



                            {/* ---------------judge criteria start----------------  */}
                            {
                                judgeCriteriaModal && (
                                    <div className='inset-0  fixed flex'>
                                        {/* backdrop start */}
                                        <div className='absolute inset-0 bg-black bg-opacity-50' onClick={handlejudgeCriteriaModalClose}>
                                        </div>
                                        {/* backdrop end */}


                                        {/* modal panel start  */}
                                        <div className={`absolute top-[15vh] right-0 w-[40%] bg-theme_yellow_light overflow-auto transition-transform duration-300 ease-out `}
                                            style={{ height: 'calc(100% - 10vh)' }}
                                        >

                                            <div className='p-6'>
                                                <div className='flex justify-between items-center mb-4'>
                                                    <h2>
                                                        Add Judge Criteria
                                                    </h2>

                                                    <button
                                                        className='text-gray-600 hover:text-gray-800' onClick={handlejudgeCriteriaModalClose}>
                                                        ✕
                                                    </button>
                                                </div>
                                                <p>Create your Judging Criteria here -</p>

                                                <div>
                                                    <div>
                                                        <form >
                                                            <div className='w-full my-[10px]'>
                                                                <div>
                                                                    <label >Judge Criteria:</label>
                                                                </div>
                                                                <input value={judgecriteria} onChange={(e) => setjudgecriteria(e.target.value)} type="text" className='w-[70%]' />
                                                            </div>


                                                            <div className='my-[20px] flex gap-4'>
                                                                <button onClick={submitJudgeCriteria} className='bg-theme_yellow_dark_transparent text-white px-[20px] py-[10px] rounded-lg'>Submit</button>
                                                                <button onClick={clearFields} className='bg-theme_border text-theme_black px-[20px] py-[10px] rounded-lg'>Clear</button>
                                                            </div>
                                                        </form>
                                                    </div>

                                                    <div className='my-[10px]'>
                                                        <table className='border border-separate'>
                                                            <thead className=''>
                                                                <th>Sno.</th>
                                                                <th>Judge Criteria</th>
                                                                <th>Edit</th>
                                                                <th>Delete</th>
                                                            </thead>
                                                            <tbody>

                                                                {
                                                                    getAllJudgeCriteria && getAllJudgeCriteria.map((item, index) => {
                                                                        return (

                                                                            <tr key={index} className='text-center '>
                                                                                <td>{index + 1}</td>
                                                                                <td>{item.name}</td>
                                                                                <td><RiEditLine size={20} onClick={() => handleEditJudgeCriteriaModal(item)} /></td>
                                                                                <td><MdDeleteForever size={20} onClick={() => handleDeleteJudgeCriteria(item._id)} /></td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                }
                                                            </tbody>
                                                        </table>

                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                        {/* modal panel end */}

                                    </div>
                                )
                            }


                            {
                                editJudgeCriteriaModal && (
                                    <div className='inset-0 flex justify-center items-center fixed z-[50] bg-[#1c1d1f]/30' >
                                        <div className='w-[350px]'>
                                            <div className='bg-theme_blue py-[10px] px-[10px] flex justify-between'>
                                                <h5 className='text-white text-[25px]'>Edit Judge Criteria</h5>
                                                <button onClick={() => seteditJudgeCriteriaModal(false)}><IoMdClose size={30} color='white' /></button></div>
                                            {/* input field block start */}
                                            <div className='p-[10px] bg-white'>

                                                <div className='p-[5px] flex justify-between'>
                                                    <div className='w-full'>
                                                        <label htmlFor="edit_school_location">Judge Criteria:</label>
                                                        <input id='edit_school_location' value={getParticularJudgeCriteria?.name}
                                                            onChange={(e) => {
                                                                const newClassname = e.target.value
                                                                setgetParticularJudgeCriteria((prev) => ({ ...prev, name: newClassname }))
                                                                seteditJudgeCriteria(newClassname)
                                                            }
                                                            }
                                                            className='w-full p-[8px] rounded-md outline-none bg-[#121212] text-white' type="text" placeholder='Achieved' />
                                                    </div>

                                                </div>
                                                <div className=' p-[5px] flex justify-start my-[10px]'>
                                                    <button onClick={() => handleEditJudgeCriteria(getParticularJudgeCriteria._id)} className='hover:bg-[#6C7AE0] bg-[#121212] px-[15px] py-[5px] text-white rounded-md' >Update</button>
                                                </div>

                                            </div>
                                            {/* input field block end */}
                                        </div>
                                    </div>
                                )
                            }



                            {
                                deleteJudgeCriteriaModal && (
                                    <div className='inset-0 fixed flex justify-center items-center bg-black/70'>
                                        <div className='bg-theme_sky_blue text-white w-[30%] px-[10px] py-[20px] '>
                                            <div className='flex justify-between items-center pb-[20px]'>
                                                <div>
                                                    <h1 className='text-[20px]'>Delete Judge Criteria</h1>
                                                </div>
                                                <div>
                                                    <MdClose onClick={() => setdeleteJudgeCriteriaModal(false)} size={30} />
                                                </div>
                                            </div>
                                            <hr />
                                            <div className='mt-[20px] '>
                                                <p className='w-[95%] text-center'>
                                                    Deleting Judge criteria might affect your records. Do you still want to delete?
                                                </p>
                                                <div className='flex justify-around mt-[30px]'>
                                                    <button onClick={() => deleteJudgeCriteria(deleteJudgeCriteriaId)} className='px-[10px] py-[5px] bg-theme_white text-black hover:bg-theme_red hover:text-white'>Delete</button>
                                                    <button onClick={() => setdeleteJudgeCriteriaModal(false)} className='px-[10px] py-[5px] bg-theme_white text-black hover:bg-theme_green hover:text-white'>Cancel</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }



                            {/* ---------------judge criteria end----------------  */}




                            {/* ------------------school location start----------------------  */}
                            {
                                schoolLocationModal && (
                                    <div className='inset-0  fixed flex'>
                                        {/* backdrop start */}
                                        <div className='absolute inset-0 bg-black bg-opacity-50' onClick={handleSchoolLocationClose}>
                                        </div>
                                        {/* backdrop end */}


                                        {/* modal panel start  */}
                                        <div className={`absolute top-[15vh] right-0 w-[40%] bg-theme_yellow_light overflow-auto transition-transform duration-300 ease-out `}
                                            style={{ height: 'calc(100% - 10vh)' }}
                                        >

                                            <div className='p-6'>
                                                <div className='flex justify-between items-center mb-4'>
                                                    <h2>
                                                        Add School Location
                                                    </h2>

                                                    <button
                                                        className='text-gray-600 hover:text-gray-800' onClick={handleSchoolLocationClose}>
                                                        ✕
                                                    </button>
                                                </div>
                                                <p>Create your School Location here -</p>

                                                <div>
                                                    <div>
                                                        <form >
                                                            <div className='w-full my-[10px]'>
                                                                <div>
                                                                    <label >School Location:</label>
                                                                </div>
                                                                <input value={schoolLocation} onChange={(e) => setschoolLocation(e.target.value)} type="text" className='w-[70%]' />
                                                            </div>


                                                            <div className='my-[20px] flex gap-4'>
                                                                <button onClick={submitSchoolLocation} className='bg-theme_yellow_dark_transparent text-white px-[20px] py-[10px] rounded-lg'>Submit</button>
                                                                <button onClick={clearFields} className='bg-theme_border text-theme_black px-[20px] py-[10px] rounded-lg'>Clear</button>
                                                            </div>
                                                        </form>
                                                    </div>

                                                    <div className='my-[10px]'>
                                                        <table className='border border-separate'>
                                                            <thead className=''>
                                                                <th>Sno.</th>
                                                                <th>School Location</th>
                                                                <th>Edit</th>
                                                                <th>Delete</th>
                                                            </thead>
                                                            <tbody>

                                                                {
                                                                    getAllSchoolLocation && getAllSchoolLocation.map((item, index) => {
                                                                        return (

                                                                            <tr key={index} className='text-center '>
                                                                                <td>{index + 1}</td>
                                                                                <td>{item.name}</td>
                                                                                <td><RiEditLine size={20} onClick={() => handleEditSchoolLocationModal(item)} /></td>
                                                                                <td><MdDeleteForever size={20} onClick={() => handleDeleteSchoolLocationModal(item._id)} /></td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                }
                                                            </tbody>
                                                        </table>

                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                        {/* modal panel end */}

                                    </div>
                                )
                            }


                            {
                                editSchoolLocationModal && (
                                    <div className='inset-0 flex justify-center items-center fixed z-[50] bg-[#1c1d1f]/30' >
                                        <div className='w-[350px]'>
                                            <div className='bg-theme_blue py-[10px] px-[10px] flex justify-between'>
                                                <h5 className='text-white text-[25px]'>Edit School Location</h5>
                                                <button onClick={() => seteditSchoolLocationModal(false)}><IoMdClose size={30} color='white' /></button></div>
                                            {/* input field block start */}
                                            <div className='p-[10px] bg-white'>

                                                <div className='p-[5px] flex justify-between'>
                                                    <div className='w-full'>
                                                        <label htmlFor="edit_school_location">School Location:</label>
                                                        <input id='edit_school_location' value={getParticularSchoolLocation?.name}
                                                            onChange={(e) => {
                                                                const newClassname = e.target.value
                                                                setgetParticularSchoolLocation((prev) => ({ ...prev, name: newClassname }))
                                                                seteditParticularSchoolLocation(newClassname)
                                                            }
                                                            }
                                                            className='w-full p-[8px] rounded-md outline-none bg-[#121212] text-white' type="text" placeholder='School Location' />
                                                    </div>

                                                </div>
                                                <div className=' p-[5px] flex justify-start my-[10px]'>
                                                    <button onClick={() => editSchoolLocation(getParticularSchoolLocation._id)} className='hover:bg-[#6C7AE0] bg-[#121212] px-[15px] py-[5px] text-white rounded-md' >Update</button>
                                                </div>

                                            </div>
                                            {/* input field block end */}
                                        </div>
                                    </div>
                                )
                            }



                            {
                                deleteSchoolLocationModal && (
                                    <div className='inset-0 fixed flex justify-center items-center bg-black/70'>
                                        <div className='bg-theme_sky_blue text-white w-[30%] px-[10px] py-[20px] '>
                                            <div className='flex justify-between items-center pb-[20px]'>
                                                <div>
                                                    <h1 className='text-[20px]'>Delete School Location</h1>
                                                </div>
                                                <div>
                                                    <MdClose onClick={() => setdeleteSchoolLocationModal(false)} size={30} />
                                                </div>
                                            </div>
                                            <hr />
                                            <div className='mt-[20px] '>
                                                <p className='w-[95%] text-center'>
                                                    Deleting School Location might affect your records. Do you still want to delete?
                                                </p>
                                                <div className='flex justify-around mt-[30px]'>
                                                    <button onClick={() => deleteSchoolLocation(deleteSchoolLocationID)} className='px-[10px] py-[5px] bg-theme_white text-black hover:bg-theme_red hover:text-white'>Delete</button>
                                                    <button onClick={() => setdeleteSchoolLocationModal(false)} className='px-[10px] py-[5px] bg-theme_white text-black hover:bg-theme_green hover:text-white'>Cancel</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }



                            {/* ------------------school location end----------------------  */}


                            {/* -----------------upload students data start---------------  */}
                            {
                                uploadStudentsModal && (
                                    <div className='inset-0  fixed z-50 flex'>
                                        {/* backdrop start */}
                                        <div className='absolute inset-0 bg-black bg-opacity-50' onClick={handleUploadStudentsClose}>
                                        </div>
                                        {/* backdrop end */}


                                        {/* modal panel start  */}
                                        <div className={`absolute top-[15vh] right-0 w-[40%] bg-theme_yellow_light overflow-auto transition-transform duration-300 ease-out `}
                                            style={{ height: 'calc(100% - 10vh)' }}
                                        >

                                            <div className='p-6'>
                                                <div className='flex justify-between items-center mb-4'>
                                                    <h2>
                                                        Add Students Data
                                                    </h2>

                                                    <button
                                                        className='text-gray-600 hover:text-gray-800' onClick={handleUploadStudentsClose}>
                                                        ✕
                                                    </button>
                                                </div>
                                                <p>Download Sample file <a className='text-blue-700' href={sample_excel}>Download Sample</a> </p>
                                                <p>Upload students data here -</p>

                                                <div>
                                                    <div>
                                                        <form onSubmit={handleFileUpload} encType="multipart/form-data" >
                                                            <div className='w-full my-[10px]'>
                                                                <div>
                                                                    <label >Select your file:</label>
                                                                </div>
                                                                <input type="file"
                                                                    name="file"
                                                                    id="actual-btn"
                                                                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"

                                                                />
                                                            </div>


                                                            <div className='my-[20px] flex gap-4'>
                                                                <input
                                                                    type="submit"
                                                                    value="Upload"
                                                                    className="mx-[10px] px-[10px] py-[3px] rounded-md bg-theme_yellow_dark text-white hover:bg-green-800"
                                                                />
                                                                {/* <button onSubmit={handleFileUpload} className='bg-theme_yellow_dark_transparent text-white px-[20px] py-[10px] rounded-lg'>Submit</button> */}
                                                                {/* <button className='bg-theme_border text-theme_black px-[20px] py-[10px] rounded-lg'>Clear</button> */}
                                                            </div>
                                                        </form>

                                                        {/* Display upload status */}
                                                        {uploadSuccess && <p className="text-green-600">{uploadSuccess}</p>}
                                                        {uploadError && <p className="text-red-600">{uploadError}</p>}
                                                    </div>


                                                </div>

                                            </div>

                                        </div>
                                        {/* modal panel end */}

                                    </div>
                                )
                            }
                            {/* -----------------upload students data end---------------  */}






                            {/* =============================class all modals start======================  */}
                            {
                                showModalClass && showModalClass ? (
                                    <div>
                                        {/* =================================================== */}

                                        <div className='inset-0  fixed  flex'>
                                            {/* backdrop start */}
                                            <div className='absolute inset-0 bg-black bg-opacity-50' onClick={() => setshowModalClass(false)}>
                                            </div>
                                            {/* backdrop end */}


                                            {/* modal panel start  */}
                                            <div className={`absolute top-[15vh] right-0 w-[40%] bg-theme_yellow_light overflow-auto transition-transform duration-300 ease-out `}
                                                style={{ height: 'calc(100% - 10vh)' }}
                                            >

                                                <div className='p-6'>
                                                    <div className='flex justify-between items-center mb-4'>
                                                        <h2>
                                                            Add Class
                                                        </h2>

                                                        <button
                                                            className='text-gray-600 hover:text-gray-800' onClick={() => setshowModalClass(false)}>
                                                            ✕
                                                        </button>
                                                    </div>
                                                    <p>Create your classes here -</p>

                                                    <div>
                                                        <div>
                                                            <form >
                                                                <div className='w-full my-[10px]'>
                                                                    <div>
                                                                        <label >Class Name:</label>
                                                                    </div>
                                                                    <input value={class_name} onChange={(e) => setclass_name(e.target.value)} type="text" className='w-[70%]' />
                                                                </div>


                                                                <div className='my-[20px] flex gap-4'>
                                                                    <button onClick={handleCreateClass} className='bg-theme_yellow_dark_transparent text-white px-[20px] py-[10px] rounded-lg'>Submit</button>
                                                                    <button onClick={clearFields} className='bg-theme_border text-theme_black px-[20px] py-[10px] rounded-lg'>Clear</button>
                                                                </div>
                                                            </form>
                                                        </div>

                                                        <div className='my-[10px]'>
                                                            <table className='border border-separate'>
                                                                <thead className=''>
                                                                    <th>Sno.</th>
                                                                    <th>School Location</th>
                                                                    <th>Edit</th>
                                                                    <th>Delete</th>
                                                                </thead>
                                                                <tbody>

                                                                    {
                                                                        allClassDATA && allClassDATA.map((data, index) => {
                                                                            return (
                                                                                <tr className='text-center border-[1px] solid ' key={index}>
                                                                                    <td>{index + 1}</td>
                                                                                    <td>{data.name}</td>
                                                                                    <td className='flex justify-center'><FaEdit onClick={() => handleEditClass(data)} /></td>
                                                                                    <td ><MdDelete onClick={(() => { handledeletePopUp(data._id) })} /></td>
                                                                                </tr>
                                                                            )

                                                                        })
                                                                    }
                                                                </tbody>
                                                            </table>

                                                        </div>
                                                    </div>

                                                </div>

                                            </div>
                                            {/* modal panel end */}

                                        </div>
                                        {/* =================================================== */}


                                    </div>



                                ) : null
                            }

                            {
                                EditClassModal && EditClassModal ? (
                                    <div className='inset-0 flex justify-center items-center fixed z-[50] bg-[#1c1d1f]/30' >
                                        <div className='w-[350px]'>
                                            <div className='bg-theme_blue py-[10px] px-[10px] flex justify-between'><h5 className='text-white text-[25px]'>Edit Class</h5> <button onClick={() => setEditClassModal(false)}><IoMdClose size={30} color='white' /></button></div>
                                            {/* input field block start */}
                                            <div className='p-[10px] bg-white'>

                                                <div className='p-[5px] flex justify-between'>
                                                    <div className='w-full'>
                                                        <label htmlFor="edit_school_location">Class:</label>
                                                        <input id='edit_school_location' value={selectedRowData?.name}
                                                            onChange={(e) => {
                                                                const newClassname = e.target.value
                                                                setselectedRowData((prev) => ({ ...prev, name: newClassname }))
                                                                seteditClassName(newClassname)
                                                            }
                                                            }
                                                            className='w-full p-[8px] rounded-md outline-none bg-[#121212] text-white' type="text" placeholder='Enter School Location' />
                                                    </div>

                                                </div>
                                                <div className=' p-[5px] flex justify-start my-[10px]'>
                                                    <button onClick={() => editClass(selectedRowData._id)} className='hover:bg-[#6C7AE0] bg-[#121212] px-[15px] py-[5px] text-white rounded-md' >Update</button>
                                                </div>

                                            </div>
                                            {/* input field block end */}
                                        </div>
                                    </div>
                                ) : null
                            }

                            {
                                deletePopUp && deletePopUp ? (
                                    <div className='inset-0 fixed flex justify-center items-center bg-black/70 z-60' >
                                        <div className='bg-theme_sky_blue text-white w-[30%] px-[10px] py-[20px] '>
                                            <div className='flex justify-between items-center pb-[20px]'>
                                                <div>
                                                    <h1 className='text-[20px]'>Delete Class</h1>
                                                </div>
                                                <div>
                                                    <MdClose onClick={() => setdeletePopUp(false)} size={30} />
                                                </div>
                                            </div>
                                            <hr />
                                            <div className='mt-[20px] '>
                                                <p className='w-[95%] text-center'>
                                                    The Class will be deleted permanently? Do you still want to delete?
                                                </p>
                                                <div className='flex justify-around mt-[30px]'>
                                                    <button onClick={() => handleDelete(DeleteId)} className='px-[10px] py-[5px] bg-theme_white text-black hover:bg-theme_red hover:text-white'>Delete</button>
                                                    <button onClick={() => setdeletePopUp(false)} className='px-[10px] py-[5px] bg-theme_white text-black hover:bg-theme_green hover:text-white'>Cancel</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : null
                            }
                            {/* =============================class all modals end======================  */}








                            {/*========================== section all modal start============================  */}


                            {
                                showModalSection && showModalSection ? (
                                    <div>
                                        {/* <div className='fixed inset-0 flex justify-center items-center bg-black/70'>
                                    <div className=' w-[500px] bg-white'>
                                        <div className='bg-[#8321A8] text-white flex justify-between items-center px-[10px]'>
                                            <div> <h1 className='text-[30px] '>Create Section</h1></div>
                                            <div ><MdClose onClick={() => setshowModalSection(false)} size={35} /></div>
                                        </div>
                                        <div>
                                            <div className='flex'>
                                                <div className='px-[20px] mt-[10px] w-[50%]'>
                                                    <div className='text-[18px]'>
                                                        <label htmlFor="">Select Class:</label>
                                                    </div>
                                                    <div>
                                                        <select
                                                            onChange={(e) => setClassNameforSection(e.target.value)}
                                                            value={classNameforSection}
                                                            className='bg-black px-[10px] py-[5px] rounded-md text-white w-full outline-none'>
                                                            <option value="">Select Class Name</option>
                                                            {
                                                                allClassDATA && allClassDATA.map((item, index) => {
                                                                    return (
                                                                        <option key={index} value={item.name}>{item.name}</option>
                                                                    )
                                                                })
                                                            }
                                                        </select>
                                                    </div>

                                                </div>
                                                <div className='px-[20px] mt-[10px] w-[50%]'>
                                                    <div className='text-[18px]'>
                                                        <label htmlFor="">Section Name:</label>
                                                    </div>
                                                    <div className=''>
                                                       
                                                        <Select
                                                            labelId="demo-multiple-checkbox-label"
                                                            id="demo-multiple-checkbox"
                                                            style={{ color: "white" }}
                                                            className='rounded-md bg-black  w-full outline-none MuiSelect-select  '
                                                            multiple
                                                            value={sectionName}
                                                            onChange={handleChange}
                                                            placeholder='Select Section'
                                                        
                                                            renderValue={(selected) => selected.join(',')}
                                                            MenuProps={MenuProps}
                                                        >
                                                            {names && names.map((name, index) => (

                                                                <MenuItem selected className="MenuItem" key={name} value={name}>
                                                                    <Checkbox checked={sectionName.indexOf(name) > -1} />
                                                                    <ListItemText primary={name} />
                                                                </MenuItem>

                                                            ))}
                                                        </Select>
                                                    </div>

                                                </div>
                                                <div></div>
                                            </div>

                                            <div className='flex justify-center my-[10px]'>
                                                <button onClick={() => handleSubmitSection()} className='bg-[#1B1B1B] text-white px-[20px] py-[5px] font-semibold text-[15px] rounded-md'>Add</button>
                                            </div>
                                        </div>

                                        
                                        <div className='w-full h-[250px] overflow-hidden  overflow-y-scroll'>
                                            <table className='w-full'>
                                                <thead>
                                                    <tr className=' border-[1px] solid'>
                                                        <th>#</th>
                                                        <th>Class Name</th>
                                                        <th>Section Name</th>
                                                        <th>Edit</th>
                                                        <th className='text-start'>Delete</th>
                                                    </tr>
                                                </thead>
                                                <tbody className='w-full'>

                                                    {
                                                        get_section && get_section.map((item, index) => {
                                                            return (
                                                                <tr key={index} className='text-center border-[1px] solid'>
                                                                    <td>{index + 1}</td>
                                                                    <td>{item.class_name}</td>
                                                                    <td>{item.sections.join(",")}</td>
                                                                    <td onClick={() => handleEditSection(item._id)} className='flex justify-center'><FaEdit /></td>
                                                                    <td ><MdDelete onClick={() => handledeleteSectionPopUp(item._id)} /></td>
                                                                </tr>
                                                            )
                                                        })
                                                    }

                                 
                                                </tbody>
                                            </table>
                                        </div>
                                        


                                    </div>

                                </div> */}


                                        {/* ===================== */}
                                        <div className='inset-0  fixed  flex'>
                                            {/* backdrop start */}
                                            <div className='absolute inset-0 bg-black bg-opacity-50' onClick={() => setshowModalSection(false)} size={35}>
                                            </div>
                                            {/* backdrop end */}


                                            {/* modal panel start  */}
                                            <div className={`absolute top-[15vh] right-0 w-[40%] bg-theme_yellow_light overflow-auto transition-transform duration-300 ease-out `}
                                                style={{ height: 'calc(100% - 10vh)' }}
                                            >

                                                <div className='p-6'>
                                                    <div className='flex justify-between items-center mb-4'>
                                                        <h2>
                                                            Add Section
                                                        </h2>

                                                        <button
                                                            className='text-gray-600 hover:text-gray-800' onClick={() => setshowModalSection(false)} size={35}>
                                                            ✕
                                                        </button>
                                                    </div>
                                                    <p>Create your Sections here -</p>

                                                    <div>
                                                        <div>
                                                            <form >
                                                                <div className='w-full my-[10px]'>
                                                                    <div>
                                                                        <label >Select Class Name:</label>
                                                                    </div>
                                                                    {/* <input value={class_name} onChange={(e) => setclass_name(e.target.value)} type="text" className='w-[70%]' /> */}
                                                                    <select
                                                                        onChange={(e) => setClassNameforSection(e.target.value)}
                                                                        value={classNameforSection}
                                                                        className='w-[70%]'>
                                                                        <option value="">Select Class Name</option>
                                                                        {
                                                                            allClassDATA && allClassDATA.map((item, index) => {
                                                                                return (
                                                                                    <option key={index} value={item.name}>{item.name}</option>
                                                                                )
                                                                            })
                                                                        }
                                                                    </select>
                                                                </div>

                                                                <div className='w-full my-[10px]'>
                                                                    <div>
                                                                        <label >Select Section Name:</label>
                                                                    </div>
                                                                    {/* <input value={class_name} onChange={(e) => setclass_name(e.target.value)} type="text" className='w-[70%]' /> */}
                                                                    <Select
                                                                        labelId="demo-multiple-checkbox-label"
                                                                        id="demo-multiple-checkbox"
                                                                        style={{ color: "white" }}
                                                                        className='w-[70%]'
                                                                        multiple
                                                                        value={sectionName}
                                                                        onChange={handleChange}
                                                                        placeholder='Select Section'
                                                                        // onChange={handleSearchSection}
                                                                        // input={<OutlinedInput  label="Select Section" />}
                                                                        renderValue={(selected) => selected.join(',')}
                                                                        MenuProps={MenuProps}
                                                                    >
                                                                        {names && names.map((name, index) => (

                                                                            <MenuItem selected className="MenuItem" key={name} value={name}>
                                                                                <Checkbox checked={sectionName.indexOf(name) > -1} />
                                                                                <ListItemText primary={name} />
                                                                            </MenuItem>

                                                                        ))}
                                                                    </Select>
                                                                </div>


                                                                <div className='my-[20px] flex gap-4'>
                                                                    <button onClick={handleSubmitSection} className='bg-theme_yellow_dark_transparent text-white px-[20px] py-[10px] rounded-lg'>Submit</button>
                                                                    <button onClick={clearFields} className='bg-theme_border text-theme_black px-[20px] py-[10px] rounded-lg'>Clear</button>
                                                                </div>
                                                            </form>
                                                        </div>

                                                        <div className='my-[10px]'>
                                                            <table className='border border-separate'>
                                                                <thead className=''>
                                                                    <th>#</th>
                                                                    <th>Class Name</th>
                                                                    <th>Section Name</th>
                                                                    <th>Edit</th>
                                                                    <th className='text-start'>Delete</th>
                                                                </thead>
                                                                <tbody>

                                                                    {
                                                                        get_section && get_section.map((item, index) => {
                                                                            return (
                                                                                <tr key={index} className='text-center border-[1px] solid'>
                                                                                    <td>{index + 1}</td>
                                                                                    <td>{item.class_name}</td>
                                                                                    <td>{item.sections.join(",")}</td>
                                                                                    <td onClick={() => handleEditSection(item._id)} className='flex justify-center'><FaEdit /></td>
                                                                                    <td ><MdDelete onClick={() => handledeleteSectionPopUp(item._id)} /></td>
                                                                                </tr>
                                                                            )
                                                                        })
                                                                    }
                                                                </tbody>
                                                            </table>

                                                        </div>
                                                    </div>

                                                </div>

                                            </div>
                                            {/* modal panel end */}

                                        </div>
                                        {/* ===================== */}
                                    </div>
                                ) : null
                            }



                            {
                                editshowModalSection && editshowModalSection ? (
                                    <div>
                                        <div className='fixed inset-0 z-[60] flex justify-center items-center bg-black/70'>
                                            <div className=' w-[450px] bg-white'>
                                                <div className='bg-theme_blue text-white flex justify-between items-center px-[10px]'>
                                                    <div> <h1 className='text-[30px] '>Update Section</h1></div>
                                                    <div ><MdClose onClick={() => seteditshowModalSection(false)} size={35} /></div>
                                                </div>
                                                <div>
                                                    <div className='flex'>
                                                        <div className='px-[20px] mt-[10px] w-[50%]'>
                                                            <div className='text-[18px]'>
                                                                <label htmlFor="">Select Class:</label>
                                                            </div>
                                                            <div>
                                                                <select
                                                                    onChange={(e) => seteditClassNameforSection(e.target.value)}
                                                                    value={editclassNameforSection}
                                                                    className='bg-black px-[10px] py-[5px] rounded-md text-white w-full outline-none'>
                                                                    <option value="">Select Class Name</option>
                                                                    {
                                                                        allClassDATA && allClassDATA.map((item, index) => {
                                                                            return (
                                                                                <option key={index} value={item.name}>{item.name}</option>
                                                                            )
                                                                        })
                                                                    }
                                                                </select>
                                                            </div>

                                                        </div>
                                                        <div className='px-[20px] mt-[10px] w-[50%]'>
                                                            <div className='text-[18px]'>
                                                                <label htmlFor="">Section Name:</label>
                                                            </div>
                                                            <div className=''>
                                                                {/* <input className='bg-black px-[10px] py-[5px] rounded-md text-white w-full outline-none' type="text" placeholder='Section Name' /> */}
                                                                <Select
                                                                    labelId="demo-multiple-checkbox-label"
                                                                    id="demo-multiple-checkbox"
                                                                    style={{ color: "white" }}
                                                                    className='rounded-md bg-black  w-full outline-none MuiSelect-select  '
                                                                    multiple
                                                                    value={editsectionName}
                                                                    onChange={handleEditChange}
                                                                    placeholder='Select Section'
                                                                    // onChange={handleSearchSection}
                                                                    // input={<OutlinedInput  label="Select Section" />}
                                                                    renderValue={(selected) => selected.join(',')}
                                                                    MenuProps={MenuProps}
                                                                >
                                                                    {names && names.map((name, index) => (

                                                                        <MenuItem selected className="MenuItem" key={index} value={name}>
                                                                            <Checkbox checked={editsectionName.indexOf(name) > -1} />
                                                                            <ListItemText primary={name} />
                                                                        </MenuItem>

                                                                    ))}
                                                                </Select>
                                                            </div>

                                                        </div>
                                                        <div></div>
                                                    </div>

                                                    <div className='flex justify-center my-[10px]'>
                                                        <button onClick={() => handleEditSubmitSection(editsectionID)} className='bg-[#1B1B1B] text-white px-[20px] py-[5px] font-semibold text-[15px] rounded-md'>Update</button>
                                                    </div>
                                                </div>




                                            </div>

                                        </div>
                                    </div>
                                ) : null
                            }


                            {
                                deleteSectionPopUp && deleteSectionPopUp ? (
                                    <div className='inset-0 fixed flex justify-center items-center bg-black/70'>
                                        <div className='bg-theme_sky_blue text-white w-[30%] px-[10px] py-[20px] '>
                                            <div className='flex justify-between items-center pb-[20px]'>
                                                <div>
                                                    <h1 className='text-[20px]'>Delete Section</h1>
                                                </div>
                                                <div>
                                                    <MdClose onClick={() => setdeleteSectionPopUp(false)} size={30} />
                                                </div>
                                            </div>
                                            <hr />
                                            <div className='mt-[20px] '>
                                                <p className='w-[95%] text-center'>
                                                    Deleting section might affect your records. Do you still want to delete?
                                                </p>
                                                <div className='flex justify-around mt-[30px]'>
                                                    <button onClick={() => handleDeleteSection(DeleteSectionId)} className='px-[10px] py-[5px] bg-theme_white text-black hover:bg-theme_red hover:text-white'>Delete</button>
                                                    <button onClick={() => setdeleteSectionPopUp(false)} className='px-[10px] py-[5px] bg-theme_white text-black hover:bg-theme_green hover:text-white'>Cancel</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : null
                            }

                            {/*========================== section all modal end============================  */}




                            {/* ===================== default modal start=====================  */}
                            {
                                defaultModal && (
                                    <div className='inset-0  fixed  flex'>
                                        {/* backdrop start */}
                                        <div className='absolute inset-0 bg-black bg-opacity-50' onClick={handleMonthCloseModal}>
                                        </div>
                                        {/* backdrop end */}


                                        {/* modal panel start  */}
                                        <div className={`absolute top-[15vh] right-0 w-[40%] bg-theme_yellow_light overflow-auto transition-transform duration-300 ease-out `}
                                            style={{ height: 'calc(100% - 10vh)' }}
                                        >

                                            <div className='p-6'>
                                                <div className='flex justify-between items-center mb-4'>
                                                    <h2>
                                                        Update Default settings
                                                    </h2>

                                                    <button
                                                        className='text-gray-600 hover:text-gray-800' onClick={() => setdefaultModal(false)}>
                                                        ✕
                                                    </button>
                                                </div>
                                                <p>Update your default session and months-</p>

                                                <div>
                                                    <div>
                                                        <div>
                                                            <div className='w-full my-[10px]'>
                                                                <div>
                                                                    <label >Months:</label>
                                                                </div>
                                                                {/* <input value={monthsName} onChange={(e) => setmonthsName(e.target.value)} type="text" className='w-[70%]' /> */}
                                                                <div className='flex justify-between w-full'>
                                                                    <div className='w-[70%]'>
                                                                        <select value={fetchedAssessmentPeriod} onChange={(e) => setfetchedAssessmentPeriod(e.target.value)} className='w-full text-black'>
                                                                            {/* <option value="">Select Month</option> */}
                                                                            {
                                                                                allMonthsData && allMonthsData.map((item, index) => {
                                                                                    // console.log(item.name)
                                                                                    return (
                                                                                        <Fragment>
                                                                                            <option className='text-black' value={item.name}>{item.name}</option>
                                                                                        </Fragment>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </select>
                                                                    </div>
                                                                    <div className='w-[20%]'>
                                                                        <button onClick={() => handleUpdateDefaultAssessmentPeriod()} className='bg-theme_green text-theme_white px-[20px] py-[5px] rounded-lg'>Update</button>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className='w-full my-[10px]'>
                                                                <div>
                                                                    <label >Session:</label>
                                                                </div>
                                                                {/* <input value={monthsName} onChange={(e) => setmonthsName(e.target.value)} type="text" className='w-[70%]' /> */}
                                                                <div className='flex justify-between w-full'>
                                                                    <div className='w-[70%]'>
                                                                        <select value={fetchedSession} onChange={(e) => setfetchedSession(e.target.value)} className='w-full text-black'>
                                                                            {/* <option value="">Select Month</option> */}
                                                                            {
                                                                                allSessionData && allSessionData.map((item, index) => {
                                                                                    // console.log(item.name)
                                                                                    return (
                                                                                        <Fragment>
                                                                                            <option className='text-black' value={item.name}>{item.name}</option>
                                                                                        </Fragment>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </select>
                                                                    </div>
                                                                    <div className='w-[20%]'>
                                                                        <button onClick={() => handleUpdateDefaultSession()} className='bg-theme_green text-theme_white px-[20px] py-[5px] rounded-lg'>Update</button>
                                                                    </div>
                                                                </div>
                                                            </div>



                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                        {/* modal panel end */}

                                    </div>
                                )
                            }
                            {/* ===================== default modal end=====================  */}







                            {/* ====================modals end=======================================  */}




                        </div>
                    ) : null}
                </Sidebar>
            </div>
        </div>
    )
}

export default Masters